export const escapeHtml = (value: string): string =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// Matches a real HTML element tag, not stray angle brackets in text like "row time <2:00".
const HTML_TAG_RE = /<\/?[a-z][a-z0-9]*\b[^>]*>/i;

/**
 * Converts plain text to HTML, preserving line breaks: a blank line starts a new
 * paragraph, a single newline becomes a soft break. Special characters are escaped.
 */
export const plainTextToHtml = (value: string | null | undefined): string => {
  if (!value) return '';
  return value
    .split(/\n{2,}/)
    .filter(block => block.trim().length > 0)
    .map(block => `<p>${escapeHtml(block).replace(/\n/g, '<br>')}</p>`)
    .join('');
};

/**
 * Normalizes a value that may hold either plain text or HTML into HTML. Values that already
 * contain HTML are returned unchanged; plain-text values are converted via plainTextToHtml so
 * their line breaks survive. Assumes plain-text input does not contain tag-like substrings.
 */
export const normalizeToHtml = (value: string | null | undefined): string => {
  if (!value) return '';
  return HTML_TAG_RE.test(value) ? value : plainTextToHtml(value);
};
